<template>
  <v-container fluid>
    <div id="signModalTop"></div>
    <template v-if="showFail">
      <v-col cols="12">
        <v-alert dense outlined type="error">
          {{ failMsg }}
        </v-alert>
      </v-col>
    </template>
    <template v-if="startSign">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      {{$t('Pradėtas pasirašymas.')}} {{ remainingTime }} s

      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-1"
            title="Nutraukti pasirašymą"
            @click.native="cancelSigning()"
            color="secondary"
            icon="atšaukti"
          />
        </v-row>
      </v-card-actions>
    </template>

    <modal-stamp-required
      :value="showAskForStamp"
      @stampRequired="stampRequired()"
      @stampNotRequired="stampNotRequired()"
    />
  </v-container>
</template>

<script>
import axios from 'axios';
import ModalStampRequired from './ModalStampRequired.vue';

export default {
  name: 'ModalSign',
  props: {
    openSign: Boolean,
    objectId: [String, Number],
    objectType: String,
  },
  components: {ModalStampRequired},
  mixins: [],
  data() {
    return {
      showFail: false,
      failMsg: null,
      startSign: false,
      transactionId: null,
      startingTimer: 300,
      elapsedTime: 0,
      showAskForStamp: false,
      signingUrl: null,
      stampIsRequired: false,
    }
  },
  computed: {
    remainingTime() {
      return this.startingTimer - this.elapsedTime
    }
  },
  created() {

  },
  watch: {
    openSign(val) {
      if (val) {
        this.startSignature()
      }
    },
  },
  methods: {
    // Init signing process
    startSignature() {
      let url = process.env.VUE_APP_SAVITARNA_URL;
      if (url.endsWith('/')) {
        url = url.slice(0, -1);
      }
      url += '/closeWindow';
      axios.post(`gosign/initSigning`, {
          object_type: this.objectType,
          object_id: this.objectId,
          url: url,
        }).then((res) => {
          this.transactionId = res.data.transactionId
          this.signingUrl = res.data.signingUrl
          if (res.data.ask_for_stamp) {
            this.showAskForStamp = true
          } else {
            this.startSign = true
            window.open(this.signingUrl, '_blank', "width=800,height=600");
            this.startTrackingStatus()
          }
        }).catch((err) => {
          this.startSign = false
          this.showAskForStamp = false
        })
    },

    stampRequired() {
      this.stampIsRequired = true;
      this.$emit('stampDecision', true)
      axios.post(`/gosign/stamp-required/${this.transactionId}`, {
        transaction_id: this.transactionId,
        stamp_required: true,
      }).then(() => {
        this.showAskForStamp = false
        this.startSign = true
        window.open(this.signingUrl, '_blank', "width=800,height=600");
        this.startTrackingStatus()
      })
    },

    stampNotRequired() {
      this.stampIsRequired = false;
      this.$emit('stampDecision', false)
      axios.post(`/gosign/stamp-required/${this.transactionId}`, {
        transaction_id: this.transactionId,
        stamp_required: false,
      }).then(() => {
        this.showAskForStamp = false
        this.startSign = true
        window.open(this.signingUrl, '_blank', "width=800,height=600");
        this.startTrackingStatus()
      })
    },

    // Check status of signature
    checkSignature() {
      axios.get(`/gosign/checkSignature/${this.transactionId}`)
        .then(res => {
          if (res.data.status == 'Signed') {
            this.startSign = false;
            this.$emit('signed', {'toBasket': res.data?.toBasket || false})
          } else if (res.data.status == 'Canceled') {
            this.startSign = false
            this.$emit('cancelSigning')
          }
        })
    },

    // Cancel signing process
    cancelSigning() {
      axios.post(`gosign/cancelSigning/${this.transactionId}`)
        .then(() => {
          this.startSign = false
          this.$emit('cancelSigning')
        })
    },

    // Start tracking signing status
    startTrackingStatus() {
      this.elapsedTime = 0;
      let timer = setInterval(() => {
        this.elapsedTime += 1;
        // Kas 10 sekundžių tikrinti būseną
        if (this.elapsedTime % 10 == 0) {
          this.checkSignature()
        }

        // Jeigu buvo atšaukta spasirašymas
        if (this.startSign == false) {
          clearInterval(timer);
        }

        // Po tam tikro laiko atšaukti pasirašyma
        if (this.elapsedTime >= this.startingTimer) {
          this.cancelSigning();
          clearInterval(timer);
        }
      }, 1000)
    },
  },
}
</script>
<style lang="scss" scoped></style>
